<template>
    <div class="w-100">
        <header class="card-header filter-header" @click="expandCardBody">
            <div class="button is-theme">
                Advanced Search
                <div class="advance-search-icon"><i class="fas fa-search"></i></div>
            </div>
            <a class="card-header-icon" aria-label="more options">
                <span class="icon" v-if="!expanded">
                   <i class="fas fa-angle-down" aria-hidden="true"></i>
                </span>
                <span class="icon" v-if="expanded">
                   <i class="fas fa-angle-up" aria-hidden="true"></i>
                </span>
            </a>
        </header>
        <div class="card-content" v-if="expanded">
            <div class="content">
                <div class="columns" v-if="!isMobile">
                    <div class="column is-narrow">
                        <displacement-range-slider></displacement-range-slider>
                    </div>
                </div>
                <div class="columns" v-if="!isMobile">
                    <div class="column is-narrow">
                        <transmissions-specification></transmissions-specification>
                    </div>
                </div>
                <div v-if="isMobile" class="search-row row">
                    <div class="col-md-6">
                        <div class="field-control">
                            <select v-model="color" multiple>
                                <option :value="null" disabled>SELECT COLOR</option>
                                <option v-for="color in colors" :value="color.value">{{ color.label }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="field-control">
                            <select v-model="auctionGrade" multiple>
                                <option :value="null" disabled>AUCTION GRADES</option>
                                <option v-for="auction_grade in auction_grades" :value="auction_grade">{{ auction_grade }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="field-control">
                            <select v-model="port_house" multiple>
                                <option :value="null" disabled>PORT</option>
                                <option v-for="port in getRegions" :value="port">{{ port }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="columns" v-if="!isMobile">
                    <div class="column is-narrow">
                        <specification-color-palette></specification-color-palette>
                    </div>
                </div>
                <div class="columns" v-if="!isMobile">
                    <div class="column is-narrow">
                        <auction-grades></auction-grades>
                    </div>
                </div>
                <div class="columns" v-for="(region, index) in getRegions" v-if="!isMobile">
                    <div class="column">
                        <auctions :region="region" :counter="index" :key="index"></auctions>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DisplacementRangeSlider from './../../Specification/DisplacementRangeSlider.vue'
    import TransmissionsSpecification from './../../Specification/TransmissionsSpecification.vue'
    import SpecificationColorPalette from './../../Specification/SpecificationColorPalette.vue'
    import AuctionGrades from './../../Specification/AuctionGrades.vue'
    import Auctions from './../Inputs/Auctions.vue'
    export default {
        components: {
            DisplacementRangeSlider,
            TransmissionsSpecification,
            SpecificationColorPalette,
            AuctionGrades,
            Auctions,
        },
        data() {
            return {
                expanded: false,
                auction_grades: [3, 3.5, 4, 5, 6, 7, 8, 'S', 'R', 'RA', '*', '**', '***'],
                colors: [
                    {
                        value: 'pearl',
                        label: 'Pearl'
                    },
                    {
                        value: 'white',
                        label: 'White'
                    },
                    {
                        value: 'yellow',
                        label: 'Yellow'
                    },
                    {
                        value: 'orange',
                        label: 'Orange'
                    },
                    {
                        value: 'wine',
                        label: 'Wine'
                    },
                    {
                        value: 'magenta',
                        label: 'Magenta'
                    },
                    {
                        value: 'purple',
                        label: 'Purple'
                    },
                    {
                        value: 'blue',
                        label: 'Blue'
                    },
                    {
                        value: 'green',
                        label: 'Green'
                    },
                    {
                        value: 'maroon',
                        label: 'Maroon'
                    },
                    {
                        value: 'beige',
                        label: 'Beige'
                    },
                    {
                        value: 'gold',
                        label: 'Gold'
                    },
                    {
                        value: 'silver',
                        label: 'Silver'
                    },
                    {
                        value: 'grey',
                        label: 'Grey'
                    },
                    {
                        value: 'black',
                        label: 'Black'
                    }
                ]
            }
        },
        computed: {
            getRegions() {
                return this.$store.getters.getRegions
            },
            isMobile() {
                return document.documentElement.clientWidth < 450;
            },
            auctionGrade: {
                get: function () {
                    return this.$store.getters.getQueryAuctionMobileGradeStatus
                },
                set: function (value) {
                    this.$store.dispatch('handleQueryMobileGrades', value)
                }
            },
            color: {
                get: function () {
                    return this.$store.getters.getQueryMobileColor
                },
                set: function (value) {
                    this.$store.dispatch('handleQueryMobileColor', value)
                }
            },
            port_house: {
                get: function () {
                    return this.$store.getters.getQueryAuctionPorts
                },
                set: function (value) {
                    this.$store.dispatch('handleQueryMobilePort', value)
                }
            }
        },
        methods: {
            expandCardBody() {
                this.expanded = !this.expanded
            }
        },
        mounted() {
            this.$store.dispatch('fetchAuctionsData')
        },
    }
</script>

<style>
    .content ul {
        list-style: none !important;
        margin-left: 0 !important;
        margin-top: 0 !important;
    }
    .card-header:hover {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Advance/Specific/SpecificFilter.vue